import Dropdown from "app/components/shared/Dropdown";
import Icon from "app/components/shared/Icon";

type Props = {
  isAdmin?: boolean;
  flakyTestAssignmentFeatureAvailable?: boolean;
  organizationSettingsUrl?: string;
};

const NoTeamsAvailable = ({
  isAdmin,
  flakyTestAssignmentFeatureAvailable,
  organizationSettingsUrl,
}: Props) => {
  if (
    isAdmin === undefined &&
    flakyTestAssignmentFeatureAvailable === undefined
  ) {
    return null;
  }

  return (
    <Dropdown>
      <button
        aria-label="Assign flaky test"
        className="unstyled-button relative z1 py2 px3"
      >
        <Icon icon="heroicons/solid/ellipsis-vertical" size={24} />
      </button>
      <div className="p4">
        <div className="pb2 center">
          {flakyTestAssignmentFeatureAvailable ? (
            <>
              <h3>No teams found</h3>
              <p>
                Your organization has no teams to assign to this flaky test.
              </p>

              {isAdmin && organizationSettingsUrl ? (
                <p>
                  <a href={`${organizationSettingsUrl}/teams`} className="lime">
                    Add teams to this suite
                  </a>{" "}
                  from the teams page in your organization settings.
                </p>
              ) : (
                <p>
                  Ask your administrator to create teams for your organization
                  to start assigning flaky tests.
                </p>
              )}
              <a
                href="https://buildkite.com/docs/team-management/permissions"
                className="btn btn-primary col-center"
                target="_blank"
                rel="noreferrer"
              >
                Learn more about teams
              </a>
            </>
          ) : (
            <div>
              <h3>Flaky assignments</h3>
              <p>
                This feature is available to Pro and Enterprise customers only.{" "}
                <a
                  href="https://buildkite.com/docs/test-analytics/flaky-test-assignment"
                  target="_blank"
                  rel="noreferrer"
                  className="lime"
                >
                  Learn more about flaky assignments
                </a>
              </p>

              {isAdmin && organizationSettingsUrl && (
                <a
                  href={`${organizationSettingsUrl}/billing`}
                  className="btn btn-primary col-center"
                >
                  Upgrade your plan
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </Dropdown>
  );
};

export default NoTeamsAvailable;
